import { createAction } from 'redux-actions';
import { push } from 'connected-react-router';

import { billing } from '../services/api';

const customer: Customer = {
  sources: {
    data: [],
    total_count: 0,
  },
  subscriptions: {
    data: [],
    total_count: 0,
  },
  default_source: '',
  email: '',
};

type State = { customer: Customer; error?: string };

export function errorMessage(error: any) {
  return (dispatch: Function) => {
    dispatch(storeError(error.response.data.error.message));
    dispatch(push('/billing/error'));
  };
}

export function storeError(errorMessage: string) {
  return { type: 'BILLING_ERROR', message: errorMessage };
}

export function addCard(token: string) {
  return (dispatch: Function) =>
    billing
      .sendStripeToken(token)
      .then((res) => {
        dispatch(loadCustomer('/billing/added'));
      })
      .catch((res) => {
        dispatch(errorMessage(res));
      });
}

export function removeSource(source_id: string) {
  return (dispatch: Function) =>
    billing
      .removeSource(source_id)
      .then((res) => {
        dispatch(loadCustomer());
      })
      .catch((res) => {
        dispatch(errorMessage(res));
      });
}

export function addAccount(token: string, metadata: any, page: string) {
  return (dispatch: Function) =>
    billing
      .sendPlaidToken(token, metadata.account_id)
      .then((res) => {
        dispatch(loadCustomer());
        dispatch(push(page));
      })
      .catch((res) => {
        dispatch(errorMessage(res));
      });
}

export function createCustomer(email: string, location: string) {
  return (dispatch: Function) =>
    billing
      .createCustomer(email)
      .then((res) => {
        dispatch(loadCustomer(location));
      })
      .catch((res) => {
        dispatch(errorMessage(res));
      });
}

export function submittingPlan(plan: string, frequency: string) {
  return (dispatch: Function) =>
    billing
      .submitPlan(plan, frequency)
      .then((res) => {
        dispatch(loadCustomer('/billing'));
      })
      .catch((res) => {
        dispatch(errorMessage(res));
      });
}

export const receiveCustomer = createAction('RECEIVE_CUSTOMER', (data) => data);

export function loadCustomer(redirect = '') {
  return (dispatch: Function) =>
    billing.getPaymentMethods().then((json: any) => {
      dispatch(receiveCustomer(json.data));
      if (redirect) dispatch(push(redirect));
    });
}

export function changePage(page: string) {
  return (dispatch: Function) => {
    dispatch(push(page));
  };
}

export function submitPlan(plan: string, frequency: string) {
  return (dispatch: Function) => {
    dispatch(submittingPlan(plan, frequency));
  };
}

export function changeDefaultSource(id: string) {
  return (dispatch: Function) =>
    billing
      .setDefaultSource(id)
      .then((res) => {
        dispatch(loadCustomer('/billing/methods'));
      })
      .catch((res) => {
        dispatch(errorMessage(res));
      });
}

const initialState = {
  customer,
};

export default (state: State = initialState, action: any): State => {
  switch (action.type) {
    case 'RECEIVE_CUSTOMER':
      return { ...state, customer: { ...state.customer, ...action.payload } };
    case 'BILLING_ERROR':
      return { ...state, error: action.message };
    default:
      return state;
  }
};
